import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=7b658cbb&scoped=true&"
var script = {}
import style0 from "./Header2.vue?vue&type=style&index=0&id=7b658cbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b658cbb",
  null
  
)

export default component.exports